import { IMAGES } from "@/lib/api";
import { ShareButtons } from "@/components/site/ShareButtons";
import { ArmBar, ArmIntroMark, scrollToContact } from "@/components/site/Chrome";
import { ContactSection } from "@/components/site/Contact";
import { usePageMeta } from "@/hooks/useData";

const SERVICES = [
  { n: "01", t: "Survey", d: "Survey support for oil & gas operations, onshore and offshore." },
  { n: "02", t: "Oil and gas procurement", d: "Sourcing the equipment, materials and supplies your operation runs on." },
  { n: "03", t: "Marine vessel supply", d: "Supply for marine vessels serving the oil & gas sector." },
  { n: "04", t: "Related oil & gas services", d: "Support services around your project — ask us what you need." },
];

export default function OilGas() {
  usePageMeta("Oil & Gas Survey, Procurement & Vessel Supply | Grey Wolfe",
    "Grey Wolfe Limited, Nigeria: survey, oil and gas procurement, marine vessel supply and related oil & gas services, built on years of trusted relationships.",
    "https://www.greywolfeng.com/api/share/page/oil-gas/image.jpg");
  return (
    <div className="page-in">
      <section className="bg-gw-ground text-white py-24 md:py-32 overflow-hidden border-t-8 border-white" data-testid="oil-gas-page">
        <div className="max-w-6xl mx-auto px-6">
          <ArmBar current="oil-gas" />
          <ArmIntroMark arm="oil-gas" />
          <h1 className="lux gw-h1 mt-10">
            <span className="ln"><span>Trusted at sea.</span></span>
          </h1>
          <svg viewBox="0 0 1200 120" className="w-full my-12 wave" aria-hidden="true">
            <path d="M0 60 Q75 20 150 60 T300 60 T450 60 T600 60 T750 60 T900 60 T1050 60 T1200 60" fill="none" stroke="white" strokeWidth="1.5" />
            <path d="M0 90 Q75 50 150 90 T300 90 T450 90 T600 90 T750 90 T900 90 T1050 90 T1200 90" fill="none" className="stroke-gw-line" />
          </svg>
          <div className="grid md:grid-cols-2 gap-12">
            <figure className="relative aspect-[4/3] bg-gw-mid overflow-hidden m-0">
              <img src={IMAGES.oilGas} alt="Survey work at sea" className="w-full h-full object-cover" />
            </figure>
            <div className="min-w-0">
              <p className="gw-body" data-testid="oil-gas-differentiator">Years of trusted relationships in oil &amp; gas and marine supply.</p>
              <ul className="mt-8 lux text-2xl" data-testid="oil-gas-services-list">
                {SERVICES.map((s, i) => (
                  <li key={s.t} className={`py-3 border-t border-white/25 ${i === SERVICES.length - 1 ? "border-b" : ""}`}>{s.t}</li>
                ))}
              </ul>
              <button type="button" onClick={scrollToContact} data-testid="oil-gas-quote-button"
                className="inline-block mt-8 lab bg-white text-gw-ground px-6 py-4 transition-colors duration-200 hover:bg-gw-mist">
                Request a quote
              </button>
              <ShareButtons kind="page" id="oil-gas" text="Grey Wolfe Limited — survey, procurement & marine vessel supply" className="mt-8" testPrefix="oil-gas-share" />
            </div>
          </div>
        </div>
      </section>
      <section className="bg-gw-deep text-white py-24 md:py-32">
        <div className="max-w-6xl mx-auto px-6">
          <p className="lab text-gw-mist">What we do</p>
          <h2 className="lux gw-h2 mt-4 mb-12 max-w-2xl">One supplier from survey to delivery.</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-t border-white/25">
            {SERVICES.map((s) => (
              <div key={s.t} data-testid={`oil-gas-service-${s.n}`}
                className="group p-6 border-b lg:border-b-0 sm:border-r border-white/25 transition-colors duration-300 hover:bg-gw-ground">
                <p className="lab text-gw-mist">{s.n}</p>
                <p className="lux text-2xl mt-6">{s.t}</p>
                <p className="text-sm mt-4 text-gw-pale">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ContactSection defaultCompany="Grey Wolfe Limited" />
    </div>
  );
}
